import React from "react";
import InputMask from "react-input-mask";
import TextField from "@material-ui/core/TextField";

export const toMaskValue = number => {
	if (!number) return "";
	const digits = String(number).replace(/\D/g, "");
	return digits.startsWith("55") ? digits.slice(2) : digits;
};

export const fromMaskValue = masked => {
	return masked.replace(/\D/g, "");
};

const PhoneMaskInput = ({ value, onChange, error, helperText, label, placeholder, ...rest }) => (
	<InputMask
		mask="+55 (99) 99999-9999"
		maskChar=" "
		value={toMaskValue(value)}
		onChange={e => onChange(fromMaskValue(e.target.value))}
	>
		{inputProps => (
			<TextField
				{...inputProps}
				{...rest}
				label={label}
				error={error}
				helperText={helperText}
				placeholder={placeholder || "+55 (98) 99897-7943"}
				variant="outlined"
				margin="dense"
			/>
		)}
	</InputMask>
);

export default PhoneMaskInput;
